import React from "react";
import "./banner.css"; // 上のCSSをインポート

export default function ConsultBanner() {
  return (
    <div className="consult-banner-wrap">
      <div className="consult-banner-bg">
        <div className="consult-banner-overlay"></div>
        <div className="consult-banner-content">
          <div className="consult-banner-title">
            <span>「Lilial」だから出来る</span>
            <span style={{ fontWeight: 600 }}>Amazon・Rakuten</span>
            <span>販売支援で、</span>
          </div>
          <div className="consult-banner-lead">
            お客様の商品を多くの方に届けます。
          </div>
          <div className="consult-banner-desc">
            まずは無料相談で、貴社のAmazon・Rakutenの状況をお聞かせください！<br />
            サービス資料の請求も承っております。
          </div>
          <button className="consult-banner-btn"
          onClick={()=> {
            const target = document.querySelector("#contact")
            if (target) {
              target.scrollIntoView({behavior: "smooth"})
            }
          }}
          >
            運用代行の無料相談をする
            <span className="consult-banner-btn-arrow">›</span>
          </button>
        </div>
      </div>
    </div>
  );
}